import { createRouter, createWebHistory } from 'vue-router'
import Tracking from '../components/Tracking.vue'
import NotFound from '../components/NotFound.vue'

const routes = [
  {
    path: '/:barcode',
    name: 'Tracking',
    component: Tracking,
    props: true
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
